import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { ElementRef } from '@angular/core';

import * as _ from 'lodash';
declare var $: any;
@Component({
    selector: 'zoom-contact-card',
    templateUrl: './contact-card.component.html',
    styleUrls: ['./contact-card.component.scss']
})
export class ContactCardComponent implements OnInit, AfterViewInit {
    @ViewChild('emailDropdown') emailDropdown: ElementRef;
    @Input() contact;
    @Input() numberOfSelections: number;
    @Input() isVIP: boolean = false;
    @Input() hideVIP = false;
    @Output() onRemove = new EventEmitter<any>();
    @Output() onMarkAsRequired = new EventEmitter<any>();
    @Output() onUpdateContactEmailDefault = new EventEmitter<any>();
    @Output() onMarkAsVIP = new EventEmitter<any>();

    public isRequiredToggled: boolean = false;
    public showEditDropdown = false;

    public contactEmails: { name: string; value: string }[];
    public contactDisplayedEmail: string = '';
    private maximumEmailLength = 28;
    private phoneBreakpoint = 958; // sync with include-media
    private mobileBreakpoint = 620; // sync with include-media

    constructor() {}

    ngOnInit() {
        this.contactDisplayedEmail = this.contact.defaultEmail
            ? this.contact.defaultEmail
            : this.getContactEmail(this.contact);
        this.contactEmails = this.getEmailsForDropdown(this.contact.email);

        const screenWidth = window.innerWidth;
        if (screenWidth >= this.phoneBreakpoint || screenWidth <= this.mobileBreakpoint) {
            this.contactDisplayedEmail = this.shortenEmail(this.contactDisplayedEmail);
        }
    }

    ngAfterViewInit() {
        if (this.emailDropdown) $(this.emailDropdown.nativeElement).dropdown();
    }

    /**
     * There is an outlier situation where contact.email sometimes comes back as undefined
     * This should not be possible but we do the check anyway
     */
    private getContactEmail(contact) {
        return contact.email ? contact.email[0] : '';
    }

    /** Limit width to 25 characters for display purposes */
    private shortenEmail(email: string) {
        const truncatedEmailLength = this.maximumEmailLength - 3;
        if (this.contactEmails.length > 1 && email.length >= this.maximumEmailLength) {
            return email.slice(0, truncatedEmailLength) + '...';
        } else if (email.length > this.maximumEmailLength) {
            return email.slice(0, this.maximumEmailLength) + '...';
        } else {
            return email;
        }
    }

    private getEmailsForDropdown(emails: string[]) {
        return _.reduce(
            emails,
            (result, value) => {
                return result.concat({
                    name: value,
                    value
                });
            },
            []
        );
    }

    public handleRemove(id: string): void {
        this.onRemove.emit(id);
    }

    public handleMarkAsVIP(id: string) {
        this.onMarkAsVIP.emit({
            id
        });
    }

    public onEmailDropdownChange(newEmail: { name: string; value: string }) {
        this.contact.defaultEmail = newEmail.value;
        newEmail.name = this.shortenEmail(newEmail.value);
        this.showEditDropdown = !this.showEditDropdown;
        this.onUpdateContactEmailDefault.emit({ contact: this.contact });
    }
}
